export const SPECIES_OPTIONS = ["Pine", "Southern Yellow Pine", "Poplar", "Hardwood"];

const ORDERED = [...SPECIES_OPTIONS].sort((a, b) => b.length - a.length);

export function matchSpecies(description) {
  const d = (description || '').trim();
  const dl = d.toLowerCase();
  return ORDERED.find(s => dl === s.toLowerCase() || dl.startsWith(s.toLowerCase() + ' ')) || '';
}

export function speciesOrFirstWord(description) {
  return matchSpecies(description) || (description || '').trim().split(' ')[0] || '';
}

export function stripSpecies(description) {
  // Preserves trailing spaces so typing spaces in description inputs works
  const t = (description || '').trimStart();
  const m = matchSpecies(t);
  return m ? t.slice(m.length).trimStart() : t;
}
